import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { montages } = useDeliveryItemContext();

    return (
        <div className={cn("tw:pl-5.25", className)}>
            <Mapped array={montages}>{children}</Mapped>
        </div>
    );
};
